import React, {useEffect, useState} from 'react'
import {
  Button,
  Layout,
  Table,
  message,
  Spin,
  Space, DatePicker
} from 'antd';
import {Link, useNavigate, useParams} from "react-router-dom";
import { EditOutlined, FileExcelOutlined} from "@ant-design/icons";
import _ from "lodash";
import toernService from "../../../services/ToernService";
import dayjs from "dayjs";
import TableTitle from "../../base/TableTitle";
import {ToernIcon} from "../../icons/CustomIcons";

const { Content } = Layout;

const hfnFmt = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

const ToernGenehmigungberichtListe = () => {
  let {von, bis} = useParams();
  const navigate = useNavigate();

  const [messageApi, contextHolder] = message.useMessage();

  const pVon =  von ? dayjs(von, "DD-MM-YYYY") : dayjs().utc().startOf("month");
  const pBis =  bis ? dayjs(bis, "DD-MM-YYYY") : dayjs().utc();

  const [vonDatum, setVonDatum] = useState(pVon);
  const [bisDatum, setBisDatum] = useState(pBis);

  const [toernliste, setToernliste] = useState([]);
  const [loading, setloading] = useState(true);
  const [feldFilter, setFeldFilter] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");

  const error = (msg) => {
    messageApi.open({
      type: 'error', content: msg,
    });
  }

  useEffect(() => {
    ladeGenehmigteToerns()
  }, [vonDatum, bisDatum]);

  const ladeGenehmigteToerns = async () => {
    setloading(true);
    await toernService.getGenehmigungsBericht(vonDatum, bisDatum).then(
      res => {
        setloading(false);
        const gruppierteToerns = Object.values(
          res.data.reduce((acc, row) => {
            if (!acc[row.benutzer.id]) {
              acc[row.benutzer.id] = {
                key: `t_${row.benutzer.id}`,
                benutzer: row.benutzer,
                hafentage: {
                  total: 0,
                  summeKapitaen: 0,
                  summeMaschinist: 0,
                  summeSteuermann: 0,
                  summeSchiffsmechaniker: 0,
                  summeNWO_5J: 0
                },
                startzeit: null,
                endezeit: null,
                reisekilometer: 0,
                shuttlekilometer: 0,
                children: []
              }
            }
            acc[row.benutzer.id].hafentage.total += row.hafentage.total;
            acc[row.benutzer.id].hafentage.summeKapitaen += row.hafentage.summeKapitaen;
            acc[row.benutzer.id].hafentage.summeMaschinist += row.hafentage.summeMaschinist;
            acc[row.benutzer.id].hafentage.summeSteuermann += row.hafentage.summeSteuermann;
            acc[row.benutzer.id].hafentage.summeSchiffsmechaniker += row.hafentage.summeSchiffsmechaniker;
            acc[row.benutzer.id].hafentage.summeNWO_5J += row.hafentage.summeNWO_5J;
            acc[row.benutzer.id].reisekilometer += row.reisekilometer;
            acc[row.benutzer.id].shuttlekilometer += row.shuttlekilometer;
            acc[row.benutzer.id].children.push({
              id: row.id,
              key: `toern-${row.id}`,
              benutzer: row.benutzer,
              hafentage: row.hafentage,
              reisekilometer: row.reisekilometer,
              shuttlekilometer: row.shuttlekilometer,
              startzeit: row.startzeit,
              endezeit: row.endezeit
            });
            return acc;
          }, {})
        );

        setToernliste(gruppierteToerns);

      }
    ).catch((e) => {
      setloading(false);
      error(`Beim Laden der Törns ist ein Fehler aufgetreten:`);
      console.error(e);
    });
  };

  const handleChange = (pagination, filters) => {
    setFeldFilter(filters);
  };

  const changeVonDatum = (d) => {
    if (!d) {
      d = dayjs().utc();
    }
    setVonDatum(d)
    navigate("/toerns/berichte/genehmigung/"  + d.format("DD-MM-YYYY") + "/" + bisDatum.format("DD-MM-YYYY") , { replace: true})
  }

  const changeBisDatum = (d) => {
    if (!d) {
      d = dayjs().utc();
    }
    setBisDatum(d)
    navigate("/toerns/berichte/genehmigung/"  + vonDatum.format("DD-MM-YYYY") + "/" + d.format("DD-MM-YYYY") , { replace: true})
  }

  const tabletitle = () => {
    return <TableTitle icon={<ToernIcon/>}
                  filtervalues={
                    toernliste
                      .reduce(function(acc, b) {
                        acc.push(b.benutzer.vorname);
                        acc.push(b.benutzer.nachname);
                        return acc;
                      }, [])
                    .filter((value, index, array) => array.indexOf(value) === index)
                    .map(s => ({ label: s, value: s}))
                  }
                  onFilter={setGlobalFilter} >Genehmigte Törns {vonDatum.format("DD.MM.YYYY")} - {bisDatum.format("DD.MM.YYYY")}</TableTitle>
  }

  const filterData = toernliste => formatter => toernliste.map( item => ({
    text: formatter(item),
    value: formatter(item)
  }));

          const columns=[
            {
              title: 'Benutzer',
              children: [
              {
                title: 'Vorname',
                dataIndex: 'benutzer',
                key: 'benutzerVorname',
                sorter: (a, b) => a.benutzer.vorname.localeCompare(b.benutzer.vorname),
                filters: _.uniqWith(filterData(toernliste)(i => i.benutzer.vorname), _.isEqual),
                filteredValue: feldFilter.benutzerVorname || null,
                onFilter: (value, record) => record.benutzer.vorname.includes(value),
                render: (benutzer) => <>{benutzer.vorname}</>
              },
              {
                title: 'Nachname',
                dataIndex: 'benutzer',
                key: 'benutzerNachname',
                sorter: (a, b) => a.benutzer.nachname.localeCompare(b.benutzer.nachname),
                filters: _.uniqWith(filterData(toernliste)(i => i.benutzer.nachname), _.isEqual),
                filteredValue: feldFilter.benutzerNachname || null,
                onFilter: (value, record) => record.benutzer.nachname.includes(value),
                render: (benutzer) => <>{benutzer.nachname}</>
              }
            ]
            },
            {
              title: 'Törn',
              children: [
                {
                  title: 'Von',
                  dataIndex: 'startzeit',
                  key: 'startzeit',
                  render: (datum) => <>{datum ? dayjs(new Date(datum)).format('DD.MM.YYYY HH:mm'): ""}</>,
                },
                {
                  title: 'Bis',
                  dataIndex: 'endezeit',
                  key: 'endezeit',
                  render: (datum) => <>{datum ? dayjs(new Date(datum)).format('DD.MM.YYYY HH:mm'): ""}</>,
                }
              ]
            },
            {
              title: 'Hafentage',
              children: [
                {
                  title: 'Kapitän',
                  dataIndex: 'hafentage',
                  key: 'hafentageKapitaen',
                  render: (hafentage) => (hafentage && hafentage.summeKapitaen) ? hfnFmt.format(hafentage.summeKapitaen) : "",
                },
                {
                  title: 'Maschinist',
                  dataIndex: 'hafentage',
                  key: 'hafentageMaschinist',
                  render: (hafentage) => (hafentage && hafentage.summeMaschinist) ? hfnFmt.format(hafentage.summeMaschinist) : "",
                },
                {
                  title: 'Steuermann',
                  dataIndex: 'hafentage',
                  key: 'hafentageSteuermann',
                  render: (hafentage) => (hafentage && hafentage.summeSteuermann) ? hfnFmt.format(hafentage.summeSteuermann) : "",
                },
                {
                  title: 'Schiffsmechaniker',
                  dataIndex: 'hafentage',
                  key: 'hafentageSchiffsmechaniker',
                  render: (hafentage) => (hafentage && hafentage.summeSchiffsmechaniker) ? hfnFmt.format(hafentage.summeSchiffsmechaniker) : "",
                },
                {
                  title: 'NWO (5J)',
                  dataIndex: 'hafentage',
                  key: 'hafentageNWO_5J',
                  render: (hafentage) => (hafentage && hafentage.summeNWO_5J) ? hfnFmt.format(hafentage.summeNWO_5J) : "",
                },
                {
                  title: 'Summe',
                  dataIndex: 'hafentage',
                  key: 'hafentage',
                  render: (hafentage) => (hafentage && hafentage.total) ? hfnFmt.format(hafentage.total) : "",
                }
              ]
            },
            {
              title: 'Kilometer',
              dataIndex: 'reisekilometer',
              key: 'reisekilometer',
            },
            {
              title: 'Shuttle(km)',
              dataIndex: 'shuttlekilometer',
              key: 'shuttlekilometer',
            },
            {
              title: 'Aktionen',
              dataIndex: 'id',
              key: 'id',
              filteredValue: globalFilter ? [globalFilter] : null,

              onFilter: (value, record) =>
                record.benutzer.nachname.toString().toLowerCase().includes(value.toLowerCase()) ||
                record.benutzer.vorname.toString().toLowerCase().includes(value.toLowerCase())
              ,

              render: (id) => <Space>
                {id ?
                  <Link to={"/toern/" + id}><Button icon={<EditOutlined />} /></Link> :
                  ""
                }
              </Space>,
            }
          ]

          return (
            <>
              {contextHolder}
              <Layout>
                <Layout.Header style={{ backgroundColor: "#cccccc", display: 'flex',  alignItems: 'center'}}>
                  <Space>
                    {/*
                    <MonthSelector onChange = { changeMonat } value= { datum } />
                                onChange={onMonatChange}

                    */}
            <b>Von:</b><DatePicker value={vonDatum} format={['DD.MM.YYYY']} onChange={ changeVonDatum } />
            <b>Bis:</b><DatePicker value={bisDatum} format={['DD.MM.YYYY']} onChange={ changeBisDatum } />
            <Button icon={<FileExcelOutlined />} href={`/genehmigungsbericht/toerns-${vonDatum.format("DD-MM-YYYY")}_${bisDatum.format("DD-MM-YYYY")}.xlsx`} target={"_blank"}><span className="buttonLabel">Excel</span></Button>
          </Space>
        </Layout.Header>
        <Content>
          {loading ? (
            <div style={{ padding: '16px' }}>
              <Spin size="large" />
            </div>
          ) : (
            <Table title={tabletitle} size={"small"} columns={columns} dataSource={toernliste} onChange={handleChange}></Table>
          )}
        </Content>
      </Layout>
    </>
  )
}

export default ToernGenehmigungberichtListe